import { rem } from '@blueprint/ui';

const VIBRATION_INTERVAL = 30;

/*
 * the duration for one shake, aka. the time for 0 -> rem(5) -> 0 -> rem(-5) -> 0
 */
const ONE_SHAKE_DURATION = 0.35;

/*
 * how many times the button move up and down for one vibration
 */
const SHAKES_IN_ONE_VIBRATION = 3;

/**
 * getAnimationFrames
 * generate the keyFrames for animation with calculation
 */
export const getAnimationFrames = () => {
  const totalTime =
    VIBRATION_INTERVAL + ONE_SHAKE_DURATION * SHAKES_IN_ONE_VIBRATION;

  const yFrames = [
    { relativePosition: 0.25, yTranslate: rem(5) },
    { relativePosition: 0.5, yTranslate: rem(0) },
    { relativePosition: 0.75, yTranslate: rem(-5) },
    { relativePosition: 1, yTranslate: rem(0) },
  ];

  const frames = [];

  for (let shake = 0; shake < SHAKES_IN_ONE_VIBRATION; shake++) {
    yFrames.forEach(({ relativePosition, yTranslate }) => {
      const yFrameTime = (shake + relativePosition) * ONE_SHAKE_DURATION;
      const framePosition = `${(
        ((VIBRATION_INTERVAL + yFrameTime) * 100) /
        totalTime
      ).toFixed(4)}%`;

      frames.push(`
       ${framePosition} {
         transform: translateY(${yTranslate});
       }
     `);
    });
  }

  return {
    frames: frames.join('\n'),
    duration: totalTime,
  };
};
